export default __webpack_public_path__ + "static/media/scherp.3a3ab058.svg";